import React, { useEffect } from "react";

export default function License() {
    useEffect(() => {
        window?.anj_735fe70b_a30e_485e_b769_83abc62e3f5c?.init();
    }, []);

    return <div id="anj-735fe70b-a30e-485e-b769-83abc62e3f5c" data-anj-seal-id="735fe70b-a30e-485e-b769-83abc62e3f5c" data-anj-image-size="128" data-anj-image-type="basic-small" style={{maxWidth: "60px"}}></div>
};